import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import './index.css';
import App from './App';
import {FirebaseProvider} from './context/Firebase'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <FirebaseProvider>
                <App/>
            </FirebaseProvider>
        </BrowserRouter>
    </React.StrictMode>
);

